import {
    Routes,
    Route,
} from "react-router-dom";

import LoanApplicationFlow
    from "./pages/dashboard/LoanApplicationFlow.tsx";

import NLogin
    from "./pages/auth/NLoginPage.tsx";

import NVerifyOtp
    from "./pages/auth/NVerifyOtp.tsx";

import AuthEntry
    from "./pages/auth/AuthEntry.tsx";

import ProtectedRoute
    from "./components/ProtectedRoute";

import PublicRoute
    from "./components/PublicRoute";

import { ThemeProvider }
    from "./context/ThemeContext";

import MandateCallback
    from "./pages/journey/mandate/MandateCallback.tsx";

import DigiLockerCallback from "./pages/journey/kyc/DigiLockerCallback.tsx";

import AddressForm from "./pages/gateway/address.tsx";
import Approval from "./pages/gateway/preApproval.tsx";
import Scheme from "./pages/gateway/scheme.tsx";
import Tsoffline from "./pages/journey/downPayment/TransactionStatusOffline.tsx"
import DownPayment
    from "./pages/journey/downPayment/downpayment.tsx";


function App() {

    return (

        <ThemeProvider>



            <Routes>

                {/* 
                     * JOURNEY ENTRY
                     *
                     * External URL:
                     * /?code=XXXX
                     *
                     * AuthEntry exchanges the code
                     * and stores the Journey.
                     */}
                <Route
                    path="/"
                    element={<AuthEntry />}
                />


                {/*
                     * PUBLIC AUTH ROUTES
                     *
                     * Accessible only when JWT
                     * does not exist.
                     */}
                <Route
                    element={<PublicRoute />}
                >

                    <Route
                        path="/Nlogin"
                        element={<NLogin />}
                    />

                    <Route
                        path="/Nlogin/form"
                        element={<NLogin />}
                    />

                    <Route
                        path="/nverify-otp"
                        element={<NVerifyOtp />}
                    />

                </Route>

                <Route
                    path="/ndashboard/mandate/callback"
                    element={
                        <MandateCallback />
                    }
                />

                <Route
                    path="/ndashboard/kyc/digilocker/callback"
                    element={
                        <DigiLockerCallback />
                    }
                />

                <Route
                    path="/downPayment"
                    element={<DownPayment />}
                />
                
                <Route
                    path="/transactionstatusoffline"
                    element={<Tsoffline />}
                />



                {/*
                     * PROTECTED ROUTES
                     *
                     * JWT is required.
                     */}
                <Route
                    element={<ProtectedRoute />}
                >

                    <Route
                        path="/ndashboard"
                        element={
                            <LoanApplicationFlow />
                        }
                    />

                    <Route
                        path="/naddress"
                        element={<AddressForm />}
                    />

                    <Route
                        path="/napproval"
                        element={<Approval />}
                    />
                    <Route
                        path="/nscheme-selection"
                        element={<Scheme />}
                    />

                </Route>

            </Routes>



        </ThemeProvider>

    );

}

export default App;